import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd07d5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-4 radius-7" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-time-line me-2" }),
    /*#__PURE__*/_createTextVNode("Horário de Funcionamento ")
  ])
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-alert-line me-2" }, null, -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label text-muted" }, "Horário de Abertura", -1))
const _hoisted_15 = { class: "bg-white" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line me-2 text-success" }, null, -1))
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label text-muted" }, "Horário de Fechamento", -1))
const _hoisted_21 = { class: "bg-white" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-logout-box-line me-2 text-danger" }, null, -1))
const _hoisted_24 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "opening_time",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line me-2 text-success" }),
  /*#__PURE__*/_createTextVNode("Horário de Abertura ")
], -1))
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block mt-1" }, "Ex: 08:00", -1))
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "closing_time",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-logout-box-line me-2 text-danger" }),
  /*#__PURE__*/_createTextVNode("Horário de Fechamento ")
], -1))
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block mt-1" }, "Ex: 21:00", -1))
const _hoisted_36 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-alert-line me-2" }, null, -1))
const _hoisted_38 = { class: "d-flex gap-2" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-edit-line me-2" }, null, -1))
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line me-2" }, null, -1))
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_45 = {
  key: 1,
  class: "ri-save-line me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loadingOperatingHours)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_ctx.operatingHoursError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.operatingHoursError), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (!_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h6", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.operatingHours.opening_time || '--:--'), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("h6", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.operatingHours.closing_time || '--:--'), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createElementVNode("input", {
                            id: "opening_time",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingHours.opening_time) = $event)),
                            type: "time",
                            class: "form-control",
                            disabled: _ctx.savingOperatingHours
                          }, null, 8, _hoisted_29), [
                            [_vModelText, _ctx.editingHours.opening_time]
                          ]),
                          _hoisted_30
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _withDirectives(_createElementVNode("input", {
                            id: "closing_time",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingHours.closing_time) = $event)),
                            type: "time",
                            class: "form-control",
                            disabled: _ctx.savingOperatingHours
                          }, null, 8, _hoisted_34), [
                            [_vModelText, _ctx.editingHours.closing_time]
                          ]),
                          _hoisted_35
                        ])
                      ])
                    ]),
                    (_ctx.validationError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _createTextVNode(_toDisplayString(_ctx.validationError), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args))),
                      disabled: _ctx.loadingOperatingHours
                    }, [
                      _hoisted_40,
                      _createTextVNode("Editar Horário ")
                    ], 8, _hoisted_39))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args))),
                        disabled: _ctx.savingOperatingHours
                      }, [
                        _hoisted_42,
                        _createTextVNode("Cancelar ")
                      ], 8, _hoisted_41),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSaveOperatingHours && _ctx.handleSaveOperatingHours(...args))),
                        disabled: _ctx.savingOperatingHours || _ctx.validationError
                      }, [
                        (_ctx.savingOperatingHours)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                          : (_openBlock(), _createElementBlock("i", _hoisted_45)),
                        _createTextVNode(" " + _toDisplayString(_ctx.savingOperatingHours ? 'Salvando...' : 'Salvar'), 1)
                      ], 8, _hoisted_43)
                    ], 64))
              ])
            ]))
    ])
  ]))
}